import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import * as uuidV4 from "uuid/v4";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { Event } from "../../../Entity/Entities/Event/Event";
import Time from "../../../Time/Time";
import Formatter from "../../../Localization/Formatter";
import Store from "../../../Store/Store";
import { PageTransition } from "../../Partials/Spinner/PageTransition";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { NewChargeStep1 } from "./NewCoach/NewCoachContents/NewChargeStep1";
import { NewChargeStep2 } from "./NewCoach/NewCoachContents/NewChargeStep2";
import { NewChargeStep3 } from "./NewCoach/NewCoachContents/NewChargeStep3";
import { NewChargeStep4 } from "./NewCoach/NewCoachContents/NewChargeStep4";
import { NewChargeStep5 } from "./NewCoach/NewCoachContents/NewChargeStep5";
import { CounterpartyStep } from "./NewCoach/NewCoachContents/CounterpartyStep";

import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";

import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

export class CoachNewCharge extends Component {
  public defaultChargeTypeLabel: string = this.props.defaultChargeTypeLabel || null;
  public defaultChargeTypeId: string = this.props.defaultChargeTypeId || null;
  public chargeDetails;

  public defaultChargeState: any = {
    amountForCharge: "",
    invoiceDateForCharge: null,
    invoiceNumberForCharge: "",
    vatForCharge: "0,00",
    vatPercentageForCharge: 0,
    isInvoice: false,
    currencyIdForCharge: this.props.app?.settings?.user?.currency?.getCurrencyId(),
    showChargeOwnerChoice: true,
    chargeClassId: this.props.globalTypes?.ChargeType?.[this.defaultChargeTypeId]?.chargeClassId || 1,
    chargeOwnerChoice: "person",
    typeIdForCharge: this.defaultChargeTypeId || null,
    typeIdForChargeManuallyChanged: false,
    descriptionForCharge: this.defaultChargeTypeId ? `${this.trans(TypeContainer.pickLabelFromId(this.defaultChargeTypeId)), this.defaultChargeTypeLabel}, ${this.formatter.monthFullFormatDate(new Date())}` : '',
    selectedEntityForCharge: this.props.selectedObjectForNewCharge || null,
    selectedEntityForChargeManuallyChanged: false,
    selectedCounterpartyForCharge: null,
    periodForCharge: 3, // todo fix hardcoded value,
    firstDateForCharge: Time.firstDateSelectedMonth(new Date()),
    dateOfPeriodForCharge: Time.firstDateSelectedMonth(new Date()),
    descriptionForChargeIsManuallyChanged: false,
    isCreateChargeTypePopupOpen: false,
    renderChargeType: true,
    chargeTypeSelectField: null,
    isSettle: false,
    hasSettlementType: false,
    isLocked: false,
    isRemoved: false,
    isDisabled: false,
    charge: null,
    showInvoiceSwitch: true,
    hasSavingsType: false,
    openCoachCreateNewCounterparty: false,
    isCounterpartyFieldShown: true,
    name: "",
    selectedEntityForExistingCharge: null,
    objectCharges: [],
    selectedObjectChargesRows: [],
    chargeIds: [],
    createCreditProcessAmount: "",
    createCreditProcessDescription: this.trans("page/chargeupdate-preprocess/credit-defaultdescription"),
    showMore: false,
    statements: [],
  }

  public defaultState: any = {
    activeStep: 0,
    skipped: new Set(),
    openCoach: false,
    hasModifiedData: false,
    isSaving: false,
    showBackButton: true,
    isClosePreprocessDialogOpen: false,
    coachType: ChargeClassContainer.pickLabelFromId(this.defaultChargeState.chargeClassId),
    payerType: "owner",
    selectedOwner: null,
    selectedAgency: null,
    amazonFolderName: uuidV4(),
    attachments: [],
    newCharge: this.defaultChargeState,
    requestFailed: false,
    errors: null,
    chargeType: "new",
    showLoader: false,
    chargeCreatedSuccessfully: false,
    firstName: "",
    tenantChoice: "existingtenant",
    lastName: "",
    tenantType: "person",
    tenant: null,
    showNextButton: false,
    tenantFirstName: "",
    tenantLastName: "",
    companyNameTenant: "",
    companyTenant: null,

    //Occupant data
    occupantFirstName: "",
    occupantLastName: "",
    occupantDescription: this.trans("label-occupant"),
    counterpartyError: null,
    occupantsData: [],
    showAdditionalSection: false,
    counterpartySuccessfullyCreated: false,
  }

  public state = {
    ...this.defaultState
  };

  constructor(public props) {
    super(props);

    this.chargeDetails = React.createRef();
  }

  public componentWillMount() {
    this.setState(this.defaultState);

    this.setState({
      isSaving: true,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
      payload: {
        sortBy: "-firstDate",
        removed: 0,
        startDate: Time.momentify(Time.firstDateCurrentMonth()).format("YYYY-MM-DD"),
      },
      onSuccess: (data) => {
        this.setState({
          statements: data.financialStatements.sort((a, b) => b.id - a.id).sort((a, b) => b.firstDate > a.firstDate),
          isSaving: false,
        })
      }
    });

    this.setState({
      openCoach: this.props.openCoach
    });

    if (this.props.activeStep) {
      this.setState({
        activeStep: this.props.activeStep
      });
    }

    if (this.props.coachType) {
      this.setState({
        coachType: this.props.coachType,
        newCharge: {
          ...this.state.newCharge,
          chargeClassId: this.props.coachType === "Payable" && 2,
          isInvoice: this.props.coachType === "Payable" ? true : false
        }
      });
    }

    if (this.props.selectedObjectForNewCharge) {
      this.setState({
        chargeType: "object",
        selectedOwner: this.props.selectedOwnerForNewCharge
      });
    }
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      openCoach: nextProps.openCoach
    });
  }

  public clearState = () => {
    this.setState({
      ...this.defaultState
    });
  }

  public onCloseCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);

    if (typeof this.props.onCloseCoach === "function") {
      this.props.onCloseCoach.call(this, this.state.chargeCreatedSuccessfully, this.state.charge);
    }
    this.setState({
      openCoach: false
    })
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    switch (this.state.coachType) {
      case "Receivable":
        return [
          this.trans("coach/newcharge-step1/title"),
          this.trans("coach/newcharge-step2/title-type/tobereceived"),
          this.trans("coach/newcharge-step3/step-title-tobereceived"),
          this.trans("label-counterparty"),
          this.trans("coach/newcharge-step4/title"),
          this.trans("summary"),
          this.trans("menuitem-finish"),
        ];
      case "Payable":
        return [
          this.trans("coach/newcharge-step1/title"),
          this.trans("coach/newcharge-step2/title-type/tobepaid"),
          this.trans("coach/newcharge-step3/step-title-tobepaid"),
          this.trans("label-counterparty"),
          this.trans("coach/newcharge-step4/title"),
          this.trans("summary"),
          this.trans("menuitem-finish"),
        ];
      case "registerIncomingInvoice":
        return [
          this.trans("coach/newcharge-step1/title"),
          this.trans("coach/newcharge-step2/title-type/registerIncomingInvoice"),
          this.trans("coach/newcharge-step3/title-type/registerIncomingInvoice"),
          this.trans("label-counterparty"),
          this.trans("coach/newcharge-step4/title"),
          this.trans("summary"),
          this.trans("menuitem-finish"),
        ];
    }
  }

  public save = (): any => {
    this.setState({
      errors: null,
      counterpartyError: null,
      showLoader: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_CREATE_CLEAR
    });

    const charge: any = {
      amount: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2)),
      currency: this.state.newCharge?.currencyIdForCharge,
      type: this.state.newCharge?.typeIdForCharge,
      period: this.state.newCharge?.periodForCharge,
      firstDate: Time.formatOrNull(this.state.newCharge?.firstDateForCharge),
      dateOfPeriod: Time.formatOrNull(this.state.newCharge?.dateOfPeriodForCharge),
      dueDate: Time.formatOrNull(Time.firstDateSelectedMonth(this.state.newCharge?.dateOfPeriodForCharge)),
      description: this.state.newCharge?.descriptionForCharge,
      invoiceDate: Time.formatOrNull(this.state.newCharge?.invoiceDateForCharge),
      invoiceNumber: this.state.newCharge?.invoiceNumberForCharge,
      isInvoice: this.state.newCharge?.isInvoice,
      amazonFolderName: this.state.amazonFolderName
    };

    if (this.state.newCharge?.selectedEntityForCharge instanceof Property) {
      charge.propertyId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Unit) {
      charge.unitId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Contract) {
      charge.contractId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Company) {
      charge.ownerId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Event) {
      charge.eventId = this.state.newCharge?.selectedEntityForCharge?.id;
    }

    if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Person) {
      charge.contactId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
    }

    if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Company) {
      charge.companyId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
    }

    if (!this.state.newCharge.selectedEntityForCharge) {
      charge.ownerId = this.state.selectedOwner?.id || this.state.selectedAgency?.id;
    }

    if (this.state.attachments.length > 0) {
      charge.attachments = this.state.attachments;
    }

    if (!this.state.newCharge?.isCounterpartyFieldShown) {
      charge.name = this.state.newCharge?.name;
    }

    if (!this.state.newCharge?.isInvoice) {
      charge.vat = null;
    }

    if (this.state.newCharge?.isInvoice && this.state.newCharge?.vatForCharge) {
      charge.vat = parseFloat(this.state.newCharge?.vatForCharge.replace(",", "."));
    }

    return this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_START,
        payload: {
          charge: charge
        },
        onSuccess: (charge: ChargeInterface) => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.setState({
            charge: charge,
            requestFailed: false,
            showBackButton: false,
            activeStep: 6,
            showLoader: false,
            chargeCreatedSuccessfully: true
          });
        },
        onError: (err) => {
          return this.setState({
            hasModifiedData: true,
            requestFailed: true,
            errors: err,
            showLoader: false,
            chargeCreatedSuccessfully: false,
            // If we get error from counterparty step, show errors on counterparty step
            counterpartyError: err.fields.some(el => {
              return el === "contactId" || el === "companyId" || el === "name"
            }) ? err.errorId : null,
            activeStep: err.fields.some(el => {
              return el === "contactId" || el === "companyId" || el === "name"
            }) ? 3 : 2
          });
        }
      });
    });
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.coachStartStep1();
  }

  public startStep2 = () => {
    if (!this.state.selectedOwner && !this.state.selectedAgency) {
      this.setState({
        isDisabled: true
      })
      return;
    };
    return this.coachStartStep2();
  }

  public startStep3 = () => {
    if (this.state.coachType !== "receivableCreditInvoice" || this.state.coachType !== "payableCreditInvoice") {
      if (!this.state.newCharge.selectedCounterpartyForCharge) {
        this.setState({
          isDisabled: true
        })
      }
      return this.coachStartStep3();
    }
    // TODO save new credit charge
  }

  public startStep4 = () => {
    // Add some validation for counterparty selection?
    return this.coachStartStep4();
  }

  public startStep5 = () => {
    return this.coachStartStep5();
  }

  public startStep6 = () => {
    return this.coachStartStep6();
  }

  //Methods for step logic
  public coachStartStep1 = () => {
    this.plusOneStep();
  }

  public coachStartStep2 = () => {
    this.plusOneStep();
  }

  public coachStartStep3 = () => {
    this.plusOneStep();
  }

  public coachStartStep4 = () => {
    this.plusOneStep();
  }

  public coachStartStep5 = () => {
    this.plusOneStep();
  }

  public coachStartStep6 = () => {
    this.save();
  }

  //Methods
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public changeCoachType = (event) => {
    const type = event.target.value;
    let classId;
    if (type === "registerIncomingInvoice") {
      classId = 2
    }
    if (type === "receivableCreditInvoice") {
      classId = 2
    }
    if (type === "payableCreditInvoice") {
      classId = 1
    }
    this.defaultChargeState.chargeClassId = ChargeClassContainer.pickIdFromLabel(type) || classId;
    this.setState({
      coachType: type,
      newCharge: {
        ...this.defaultChargeState,
        chargeClassId: ChargeClassContainer.pickIdFromLabel(type) || classId,
        isInvoice: type === "registerIncomingInvoice" ? true : false
      }
    }, () => {
      if (this.props.selectedObjectForNewCharge) {
        this.changeClassIdForCharge(this.state.newCharge.chargeClassId);
      }
    });
  }

  public changePayerType = (event) => {
    const type = event.target.value;
    const agency = this.getAgency();
    if (type === "agency") {
      this.setState({
        payerType: type,
        selectedOwner: null,
        selectedAgency: agency,
        ownerErrorMessage: null,
        newCharge: {
          ...this.defaultChargeState,
          isInvoice: this.state.coachType === "registerIncomingInvoice" ? true : false
        }
      });
    }
    if (type === "owner") {
      this.setState({
        payerType: type,
        selectedAgency: null,
        ownerErrorMessage: null,
        newCharge: {
          ...this.defaultChargeState,
          isInvoice: this.state.coachType === "registerIncomingInvoice" ? true : false
        }
      });
    }
    this.clearBackEndErrors();
  }

  public step6Details = () => {
    // TODO: We may not need fail page on step 6
    if (this.state.requestFailed) {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("result")}
          />
          <div style={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>{this.image.getAvatar("info", { size: 62 })}</div>
          <div className="info-text-gray center">
            {this.trans("charge-creation-failed")}
          </div>
          <div className="info-text-gray center">
            {this.state.errors?.message}
          </div>
          <div className="info-text-gray center">
            {this.state.errors?.fields.length && this.state.errors.fields.map(field => (
              <span>{field}, </span>
            ))}
          </div>
        </div>
      )
    } else {
      return (
        <div className="coach-content-wrapper">
          <Title
            title={this.trans("result")}
          />
          <div style={{display: "flex", justifyContent: "center", marginBottom: "30px"}}>{this.image.getAvatar("success", { size: 62 })}</div>
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-de", {entity: this.trans("title-charge").toLowerCase()})}
          />
        </div>
      )
    }
  };

  public selectCompany = (owner) => {
    const ownerLang = this.state.selectedOwner?.generalContact?.languageTypeId === 1 ? 'en-US' : 'nl-NL';
    const lang = ownerLang || Store.getConfigurator().getState().app.settings.agency.defaultLanguage.iso;
    const firstDateOfCurrentMonth = (Time.momentify(new Date())).format("YYYY-MM-01");
    const ownerStatements = this.state.statements && this.state.statements?.filter((statement) => statement?.ownerId === owner.id);
    const ownerStatementsForCurrentMonth = ownerStatements?.filter((statement) => (Time.momentify(statement?.firstDate)).format("YYYY-MM-01") === firstDateOfCurrentMonth);
    const ownerStatement = ownerStatementsForCurrentMonth.length ? ownerStatementsForCurrentMonth[0] : null;
    let date;

    if (ownerStatement && !ownerStatement.locked) {
      date = ownerStatement.firstDate;
    } else {
      const firstNotClosedStatementInNextPeriods = ownerStatements.filter((statement) => statement?.firstDate > new Date()).findLast((statement) => !statement.locked);
      date = firstNotClosedStatementInNextPeriods ? firstNotClosedStatementInNextPeriods?.firstDate : Time.momentify((ownerStatements[0])?.firstDate).add(1, "months");
    }

    this.defaultChargeTypeLabel ?
    this.setState({
      selectedOwner: owner,
      ownerErrorMessage: null,
      newCharge: {...this.state.newCharge, firstDateForCharge: date, descriptionForCharge: `${this.trans(`Other_${this.state.coachType}`, {}, lang)}, ${Time.momentify(this.state.newCharge?.dateOfPeriodForCharge).locale(lang).format("MMMM")}`},
    })
    : this.setState({
      selectedOwner: owner,
      ownerErrorMessage: null,
      newCharge: {...this.state.newCharge, firstDateForCharge: date},
    })
  }

  public clearCompany = () => {
    this.setState({ selectedOwner: null})
  }

  public handleChargeStateChange = (data) => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        ...data
      }
    })
  }

  public clearEntityForCharge = (): void => {
    this.setState({
        newCharge: {
          ...this.state.newCharge,
          selectedEntityForCharge: null,
          hasModifiedData: true
      }
    });
  }

  public selectCounterpartyForCharge = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: entity,
        hasModifiedData: true,
      },
      isDisabled: false
    });
  }

  public clearCounterpartyForCharge = (): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: null,
        hasModifiedData: true,
      },
      isDisabled: true
    });
  }

  public changeDescriptionForCharge = (event): void => {
    const description: string = event.target.value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        descriptionForCharge: description,
        hasModifiedData: true,
        descriptionForChargeIsManuallyChanged: true
      }
    });
  }

  public changeClassIdForCharge = (value): void => {
    let chargeClassId: number = value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        chargeClassId: String(chargeClassId)
      }
    }, () => {
      // when we change class we should automatically change type
      const typeId: number = Number(this.state.newCharge?.chargeClassId) == ChargeClassContainer.pickIdFromLabel("Payable") ?
                             TypeContainer.pickIdFromLabel("Other_payable") :
                             TypeContainer.pickIdFromLabel("Other_receivable");
      this.changeTypeIdForCharge(null, {props: {value: typeId}})
    });
  }

  public handleChangeIsInvoice = () => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        isInvoice: !this.state.newCharge.isInvoice
      }
    })
  }

  public selectDate = (date: Date, identifier: string): void => {
    let selectedDate = date;

    if (date) {
      if ((identifier === "dateOfPeriodForCharge") ||
         (identifier === "firstDateForCharge" && this.state.newCharge?.periodForCharge === 3)) {  // todo fix hardcoded value
        selectedDate = Time.firstDateSelectedMonth(date);
      }
    }

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        [identifier]: selectedDate,
        hasModifiedData: true
      }
    }, () => {
      if (identifier === "dateOfPeriodForCharge") {
        let typeName;
        const ownerLang = this.state.selectedOwner?.generalContact?.languageTypeId === 1 ? 'en-US' : 'nl-NL'
        const lang = ownerLang || Store.getConfigurator().getState().app.settings.agency.defaultLanguage.iso
        if (!!this.state.newCharge?.typeIdForCharge) {
          const type = this.getChargeTypeBySelect(this.state.newCharge?.typeIdForCharge);
          typeName = this.trans(type?.label, {}, lang)
        }

        if (!this.state.newCharge?.descriptionForChargeIsManuallyChanged) {
          this.setDescriptionEqualToType(typeName, Time.momentify(this.state.newCharge?.dateOfPeriodForCharge).locale(lang).format("MMMM YYYY"));
        }
      }
    });
  }

  public changeVatForCharge = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2));
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber = vatNumber / (amountForCharge - vatNumber) * 100;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        vatForCharge: vat,
        vatPercentageForCharge: isNaN(vatPercentageNumber) ? 0 : this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
        hasModifiedData: true
      }
    });
  }

  public changeVatPercentageForCharge = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2));
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vatPercentage)).replace(",", ".")).toFixed(2));
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        vatForCharge: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        vatPercentageForCharge: vatPercentage,
        hasModifiedData: true
      }
    });
  }

  public changeCurrencyIdForCharge = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        currencyIdForCharge: currency,
        hasModifiedData: true
      }
    });
  }

  public changeTypeIdForCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);
      const ownerLang = this.state.selectedOwner?.generalContact?.languageTypeId === 1 ? 'en-US' : 'nl-NL'
      const lang = ownerLang || Store.getConfigurator().getState().app.settings.agency.defaultLanguage.iso

      const typeName = Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)
      const vat = type.label === "Agency_fee" ? this.props.app.settings?.agency?.vatPercentage : null;

      this.setState({
        newCharge: {
          ...this.state.newCharge,
          typeIdForCharge: type?.id,
          typeIdForChargeManuallyChanged: true,
          isInvoice: type.label === "Agency_fee" ? true : this.state.newCharge?.isInvoice,
        }
      }, () => this.setDescriptionEqualToTypeAndVat(typeName, Time.momentify(this.state.newCharge?.dateOfPeriodForCharge).locale(lang).format("MMMM"), vat));
    }
  }

  public getStatementPeriodForCharge = () => {
    const payload: any = {
      statementPeriod: Time.formatOrNull(this.state.newCharge?.firstDateForCharge)
    };

    if (this.state.newCharge?.selectedEntityForCharge instanceof Property) {
      payload.propertyId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Unit) {
      payload.unitId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Contract) {
      payload.contractId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Company) {
      payload.ownerId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    if (this.state.newCharge?.selectedEntityForCharge instanceof Event) {
      payload.eventId = this.state.newCharge?.selectedEntityForCharge.id;
    }

    return this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_PERIOD,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        if (data?.statementPeriod) {
          this.selectDate(new Date(data?.statementPeriod), "firstDateForCharge");
        }
      }
    })
  }

  public selectEntityForCharge = (entity: PropertyInterface | UnitInterface | ContractInterface): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedEntityForCharge: entity,
        selectedEntityForChargeManuallyChanged: true,
        hasModifiedData: true
      }
    });
  }

	public changeAmountForCharge = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);
    if (this.state.newCharge?.vatPercentageForCharge || this.state.newCharge?.vatPercentageForCharge === 0) {
      let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;
      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.vatPercentageForCharge)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;
      const vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;
      return this.setState({
        newCharge: {
          ...this.state.newCharge,
          vatForCharge: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
          amountForCharge: amount,
          hasModifiedData: true
        }
      });
    }

    if (this.state.newCharge?.vatForCharge) {
      let vat: string = this.state.newCharge?.vatForCharge;
      vat = this.formatter.formatSigns(vat);

      let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      const vatPercentageNumber = vatNumber / (amountForCharge - vatNumber) * 100;

      return this.setState({
        newCharge: {
          ...this.state.newCharge,
          vatPercentageForCharge: isNaN(vatPercentageNumber) ? 0 : this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
          amountForCharge: amount,
          hasModifiedData: true
        }
      });
    }

    return this.setState({
      newCharge: {
        ...this.state.newCharge,
        vatForCharge: "",
        vatPercentageForCharge: "",
        amountForCharge: amount,
        hasModifiedData: true
      }
    });
  }

  public changeInvoiceNumberForCharge = (event): void => {
    const invoiceNumber: string = event.target.value;

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        invoiceNumberForCharge: invoiceNumber,
        hasModifiedData: true,
      }
    });
  }


  public setDescriptionEqualToType(typeName: string, date: string) {
    if (!this.state.newCharge?.descriptionForChargeIsManuallyChanged) {
      if (!!typeName) {
        this.setState({
          newCharge: {
            ...this.state.newCharge,
            descriptionForCharge: typeName + ", " + date
          }
        });
      } else {
        this.setState({
          newCharge: {
            ...this.state.newCharge,
            descriptionForCharge: date
          }
        });
      }
    }
  }

  public setDescriptionEqualToTypeAndVat(typeName: string, date: string, vat: number) {
    if (!this.state.newCharge?.descriptionForChargeIsManuallyChanged) {
      let vatNumber, vatPercentageNumber;

      if (!vat) {
        vatNumber = null;
        vatPercentageNumber = null;
      }

      if (!!vat) {
        vatPercentageNumber = vat;

        let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2));
        amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;
    
        vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;
    
        vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;
      }
  
      if (!!typeName) {
        this.setState({
          newCharge: {
            ...this.state.newCharge,
            descriptionForCharge: typeName + ", " + date,
            vatForCharge: vatPercentageNumber ? this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false) : this.state.vatForCharge,
            vatPercentageForCharge: vatPercentageNumber ? vatPercentageNumber : this.state.vatPercentageForCharge,
          }
        });
      } else {
        this.setState({
          newCharge: {
            ...this.state.newCharge,
            descriptionForCharge: date,
            vatForCharge: vatPercentageNumber ? this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false) : this.state.vatForCharge,
            vatPercentageForCharge: vatPercentageNumber ? vatPercentageNumber : this.state.vatPercentageForCharge,
          }
        });
      }
    }
  }

  public getChargeTypeBySelect = (id) => {
    const chargeType = Store.getConfigurator().getState().globalTypes?.ChargeType;
    if (!!id) {
      for (const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  }

  // START OF CREDIT CHARGE METHODS

  public createCredit = (): void => {
    const charge = this.props.charge ? this.props.charge : this.state.newCharge.charge;
    this.setState({
      showLoader: true
    });
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_CREDIT_START,
        payload: {
          charge: charge,
          amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.newCharge.createCreditProcessAmount)).replace(",", ".")).toFixed(2)),
          description: this.state.newCharge.createCreditProcessDescription,
          invoiceDate: Time.formatOrNull(this.state.newCharge.invoiceDateForCharge),
          invoiceNumber: this.state.newCharge.invoiceNumberForCharge,
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
          this.setState({
            showLoader: false
          });

          // this.onCloseCreateCreditInvoiceCoach();

          if (typeof this.props.initializePage === "function") {
            return this.props.initializePage.call(this, this.props.charge?.id)
          }

          this.redirect(`/app/charge/update/${charge?.id}`);

        },
        onError: () => {
          this.setState({
            showLoader: false,
            anchorEl: null
          });
        }
      });
    });
  }

  public selectEntityForExistingCharge = (entity: PropertyInterface | UnitInterface | ContractInterface): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedEntityForExistingCharge: entity,
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: []
      }
    }, () => {
      // after selecting an object should fetch charges related to this object
      this.fetchExistingCharges();
    });
  }

    // should fetch charges for list related to contact/company or to some object
  public fetchExistingCharges = (): void => {
    const mainPayload: any = {
      chargeClassId: this.state.newCharge.chargeClassId,
      isAfterStartDate: 1, // do not fetch charges before start date
    };

    mainPayload.paid = 0

    // fetch charges for selected object
    if (!!this.state.newCharge.selectedEntityForExistingCharge) {
      const payload = {...mainPayload};

      if (this.state.newCharge.selectedEntityForExistingCharge instanceof Property) {
        payload.propertyId = this.state.newCharge.selectedEntityForExistingCharge.id;
      }

      if (this.state.newCharge.selectedEntityForExistingCharge instanceof Unit) {
        payload.unitId = this.state.newCharge.selectedEntityForExistingCharge.id;
      }

      if (this.state.newCharge.selectedEntityForExistingCharge instanceof Contract) {
        payload.contractId = this.state.newCharge.selectedEntityForExistingCharge.id;
      }

      if (this.state.newCharge.selectedEntityForExistingCharge instanceof Company) {
        payload.ownerId = this.state.newCharge.selectedEntityForExistingCharge.id;
      }
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGES_NOT_SAVE_LIST,
        payload: {...payload},
        onSuccess: (data) => {
          const filteredCharges = data.charges.filter(charge => charge.type.id !== TypeContainer.pickIdFromLabel("Settlement"));
          this.setState({
            newCharge: {
              ...this.state.newCharge,
              objectCharges: filteredCharges
            }
          })
        }
      })
    }
  }

  public clearEntityForExistingCharge = (): void => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        selectedEntityForExistingCharge: null,
        selectedDirectIndirectChargesRows: [],
        selectedObjectChargesRows: [],
        chargeIds: [],
        objectCharges: [],
        charge: null
      }
    });
  }

  public onObjectChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const chargeId: number = this.state.newCharge.objectCharges[row].id;


    this.selectUnselectObjectCharge(row, chargeId);

  }

  public selectUnselectObjectCharge = (row: number, chargeId: number) => {
    if (this.state.newCharge.selectedObjectChargesRows.includes(row)) {
      const selectedObjectChargesRows = this.state.newCharge.selectedObjectChargesRows.filter(rowId => rowId !== row);
      const chargeIds =  this.state.newCharge.chargeIds.filter(id => id !== chargeId);
      this.setState({
        newCharge: {
          ...this.state.newCharge,
          selectedDirectIndirectChargesRows: [],
          selectedObjectChargesRows: selectedObjectChargesRows,
          chargeIds: chargeIds
        }
      });
    } else {
      this.setState({
        newCharge: {
          ...this.state.newCharge,
          selectedDirectIndirectChargesRows: [],
          selectedObjectChargesRows: [row],
          chargeIds: [chargeId]
        }
      }, () => {
        if (this.state.newCharge.chargeIds.length > 0) {
          const charge = this.state.newCharge.objectCharges.find(elem => elem?.id === this.state.newCharge.chargeIds[0])
          this.setState({
            newCharge: {
              ...this.state.newCharge,
              hasModifiedData: true,
              charge: charge,
              createCreditProcessAmount: Formatter.simpleFormatNumber(charge.amountRemaining),
              invoiceDateForCharge: charge?.invoiceDate,
              invoiceNumberForCharge:  charge?.invoiceNumber,
              createCreditProcessDescription: charge?.description,
              firstDateForCharge: charge?.firstDate
            }
          });
        }
      });
    }
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
			return
		}

    if((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")}`
    } else if((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")}`
    } else if(charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()){
      status = `${this.trans("status-to-pay")}`
    } else if(charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()){
      status = `${this.trans("status-to-receive")}`
    } else if(charge.isFullyPaid() && charge?.isReceivable){
      status = `${this.trans("status-received")}`
    } else if(charge.isFullyPaid() && charge?.isPayable){
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }

  public changeView = () => {
    this.setState({
      showAllFields: !this.state.showAllFields,
    });
  }

  public selectDateForCreditCharge = (date: Date, identifier: string): void => {
    if(!date && (identifier === "firstDateOfStatementPeriodForPayment" || identifier === "dateOfThePayment" || identifier === "paymentDateQuickOption")){
      return;
    }

    this.setState({
      newCharge: {
        ...this.state.newCharge,
        [identifier]:  date, // todo fix hardcoded value
      }
    });
  }

  public handleShowMore = () => {
    this.setState({
      newCharge: {
        ...this.state.newCharge,
        showMore: !this.state.newCharge.showMore
      }
    })
  }

  public changeTenantChoice = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantChoice: choice,
      tenant: null,
      firstName: "",
      showNextButton: false,
      isDisabled: true,
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: null
      }
    });
  }

  public chooseTenantType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      tenantType: choice,
      tenantFirstName: "",
      tenantLastName: "",
      companyNameTenant: ""
    });
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      tenant: entity,
      isDisabled: false,
      newCharge: {
        ...this.state.newCharge,
        selectedCounterpartyForCharge: entity
      }
    })
  }

  public clearTenant = (): void => {
    this.setState({
      tenant: null,
      isDisabled: true
    });
  }

  public handleInputChange = (event, state): void => {
    this.setState({
      [state]: event.target.value
    })
  }

  public getPayloadForPerson = (type): any => {
    let pageTemplate = type;
    return {
      firstName: type === "tenant" ? this.state.tenantFirstName : this.state.firstName,
      lastName:  type === "tenant" ? this.state.tenantLastName : this.state.lastName,
      profession: "",
      email: "",
      phone1: "",
      phone2: "",
      contactRoleId: null,
      mainBankAccountId: "",
      companyId: null,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: pageTemplate,
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
    };
  }

  public getPayloadTenant = (): any => {
    const pageTemplate = "person";

    return {
      person: {
        firstName: this.state.tenantFirstName,
        lastName: this.state.tenantLastName,
        profession: "",
        email: "",
        phone1: "",
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2
      }
    };
  }

  public createTenant = () => {
    this.setState({
      counterpartyError: null //need for clear error for occupant fields
    }, () => {
      if(this.state.tenantType === "person") {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
            payload: this.getPayloadTenant(),
            onSuccess: person => {
              this.setState({
                isSaving: false,
                isDisabled: false,
                tenant: person,
                counterpartySuccessfullyCreated: true,
                newCharge: {
                  ...this.state.newCharge,
                  selectedCounterpartyForCharge: person
                }
              });
            },
            onError: () => {
              this.setState({
                isSaving: false,
                isDisabled: true
              });
            }
          });
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
            payload: {
              company: {
                name: this.state.companyNameTenant,
                email: "",
                phone: "",
                mainBankAccountId: "",
                address: null,
                amazonFolderName: "",
                note: "",
                pageTemplate: "company"
              }
            },
            onSuccess: (company) => {
              this.setState({
                companyTenant: company,
                counterpartySuccessfullyCreated: true,
                showNextButton: true,
                errorFields: [],
                isSaving: false,
                isDisabled: false,
                newCharge: {
                  ...this.state.newCharge,
                  selectedCounterpartyForCharge: company
                }
              })
            },
            onError: (error) => {
              this.setState({
                errorFields: error.fields,
                isSaving: false,
                isDisabled: true
              })
            }
          });
        });
      }
    })
  }

  public render() {
    const steps = this.getSteps();
    const agency = this.getAgency();
    const agencyName = this.getAgency()?.name;
    let stepContentArr = [];
    if (this.state.coachType !== "receivableCreditInvoice" && this.state.coachType !== "payableCreditInvoice") {
      stepContentArr = [
      <NewChargeStep1
        changeCoachType={this.changeCoachType}
        coachType={this.state.coachType}
        agencyName={agency.name}
        trans={this.trans}
        chargeType={this.props.selectedObjectForNewCharge}
        payment={null}
      />,
      <NewChargeStep2
        {...this.props}
        coachType={this.state.coachType}
        agency={agency}
        agencyName={agencyName}
        trans={this.trans}
        payerType={this.state.payerType}
        changePayerType={this.changePayerType}
        selectCompany={this.selectCompany}
        clearCompany={this.clearCompany}
        selectedOwner={this.state.selectedOwner}
        chargeType={this.state.chargeType}
        ownerErrorMessage={this.state.ownerErrorMessage}
      />,
      <NewChargeStep3
        {...this.props}
        coachType={this.state.coachType}
        selectedOwner={this.state.selectedOwner}
        selectedAgency={this.state.selectedAgency}
        ref={this.chargeDetails}
        dispatch={this.props.dispatch}
        charge={this.state.newCharge}
        setState={(data) => this.handleChargeStateChange(data)}
        state={this.state.newCharge}
        changeTypeIdForCharge={this.changeTypeIdForCharge}
        selectEntityForCharge={this.selectEntityForCharge}
        clearEntityForCharge={this.clearEntityForCharge}
        changeDescriptionForCharge={this.changeDescriptionForCharge}
        selectDate={this.selectDate}
        changeInvoiceNumberForCharge={this.changeInvoiceNumberForCharge}
        changeAmountForCharge={this.changeAmountForCharge}
        handleChangeIsInvoice={this.handleChangeIsInvoice}
        changeVatPercentageForCharge={this.changeVatPercentageForCharge}
        changeVatForCharge={this.changeVatForCharge}
        chargeType={this.state.chargeType}
      />,
      <CounterpartyStep
        {...this.props}
        selectCounterpartyForCharge={this.selectCounterpartyForCharge}
        selectedCounterpartyForCharge={this.state?.newCharge?.selectedCounterpartyForCharge}
        clearCounterpartyForCharge={this.clearCounterpartyForCharge}
        tenantChoice={this.state.tenantChoice}
        changeTenantChoice={this.changeTenantChoice}
        tenant={this.state.tenant}
        companyTenant={this.state.companyTenant}
        tenantType={this.state.tenantType}
        tenantFirstName={this.state.tenantFirstName}
        tenantLastName={this.state.tenantLastName}
        chooseTenantType={this.chooseTenantType}
        selectTenant={this.selectTenant}
        clearTenant={this.clearTenant}
        handleInputChange={this.handleInputChange}
        createTenant={this.createTenant}
        coachType={this.state.coachType}
        chargeType={this.state.chargeType}
        counterpartyError={this.state.counterpartyError}
        counterpartySuccessfullyCreated={this.state.counterpartySuccessfullyCreated}
      />,
      <NewChargeStep4
        {...this.props}
        state={this.state}
        disableButtons={bool => this.setState({showLoader: bool})}
        onCreate={attachments => {this.setState({attachments: attachments})}}
      />,
      <NewChargeStep5
        {...this.props}
        state={this.state}
        getChargeTypeBySelect={this.getChargeTypeBySelect}
      />,
      this.step6Details()
    ]
  } else {
    stepContentArr = [
      <NewChargeStep1
        changeCoachType={this.changeCoachType}
        coachType={this.state.coachType}
        agencyName={agency.name}
        trans={this.trans}
        chargeType={this.props.selectedObjectForNewCharge}
        payment={null}
      />,
      <NewChargeStep3
        {...this.props}
        coachType={this.state.coachType}
        selectedOwner={this.state.selectedOwner}
        selectedAgency={this.state.selectedAgency}
        ref={this.chargeDetails}
        dispatch={this.props.dispatch}
        charge={this.state.newCharge}
        setState={(data) => this.handleChargeStateChange(data)}
        state={this.state.newCharge}
        changeTypeIdForCharge={this.changeTypeIdForCharge}
        selectEntityForCharge={this.selectEntityForCharge}
        clearEntityForCharge={this.clearEntityForCharge}
        changeDescriptionForCharge={this.changeDescriptionForCharge}
        selectDate={this.selectDate}
        changeInvoiceNumberForCharge={this.changeInvoiceNumberForCharge}
        changeAmountForCharge={this.changeAmountForCharge}
        handleChangeIsInvoice={this.handleChangeIsInvoice}
        changeVatPercentageForCharge={this.changeVatPercentageForCharge}
        changeVatForCharge={this.changeVatForCharge}
        chargeType={this.state.chargeType}
        createCredit={this.createCredit}
        selectEntityForExistingCharge={this.selectEntityForExistingCharge}
        fetchExistingCharges={this.fetchExistingCharges}
        clearEntityForExistingCharge={this.clearEntityForExistingCharge}
        onObjectChargeRowSelection={this.onObjectChargeRowSelection}
        selectUnselectObjectCharge={this.selectUnselectObjectCharge}
        renderChargeAmountHint={this.renderChargeAmountHint}
        changeView={this.changeView}
        selectDateForCreditCharge={this.selectDateForCreditCharge}
        handleShowMore={this.handleShowMore}
      />,
      <NewChargeStep5
        {...this.props}
        state={this.state}
        getChargeTypeBySelect={this.getChargeTypeBySelect}
      />,
      this.step6Details()
    ]
  }

    return (
      <>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          stepContentArr={stepContentArr}
          openCoach={this.state.openCoach}
          onCloseCoach={this.onCloseCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({activeStep, isDisabled: false})
          }}
          showBackButton={this.state.showBackButton}
          disabled={this.state.showLoader}
          disabledBack={this.state.showLoader}
          disabledNext={this.state.showLoader || this.state.isDisabled}
        />

        <PageTransition isSaving={this.state.showLoader} />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    component: state.chargeCreateDialog,
  };
};

export default connect(mapStateToProps)(
  CoachNewCharge
);
